import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import { selectPaymentProvider } from "src/store/common"

import PayPalCheckout from "src/components/PayPalCheckout"

/* Which checkout this server's provider needs.

   A per-provider component is unavoidable — PayPal, Stripe and Adyen each ship their own SDK and
   draw their own buttons, and there is no shared component to write. What is avoidable is the shop
   knowing which one: it renders `Checkout`, and a second processor is a branch here rather than an
   edit to every screen that takes money.

   Deliberately not a registry with dynamic imports. There is one provider; a lookup table for a
   single entry is indirection with nothing on the other side of it. */
const CHECKOUTS = {
  paypal: PayPalCheckout,
}

const Checkout = ({ product, onPaid, onFailed }) => {
  const { t } = useTranslation()
  const provider = useSelector(selectPaymentProvider)
  const Component = CHECKOUTS[provider]

  // A provider this build has no checkout for — a server upgraded ahead of its clients. Saying so
  // beats an empty space the player waits at, and beats guessing at a default that cannot work.
  if (!Component) {
    return <p className="p-mini shop-warning">{t("shop.checkoutUnavailable")}</p>
  }

  return <Component product={product} onPaid={onPaid} onFailed={onFailed} />
}

export default Checkout
